/*
  VAST: Geo Popup - assets/vast-geo-popup.js
  Erkennt das Besucherland über Shopifys first-party Endpoint
  /browsing_context_suggestions.json und öffnet bei Länder-Abweichung das Popup.
  Wechsel läuft über das Shopify Localization Form (Markt, Währung, Sprache,
  Domain-Redirect für Märkte mit eigener Domain).

  Keine Blur-Handler, keine Viewport-Writes (Hausregel).
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('VastGeoPopupConfig');
  var root = document.getElementById('VastGeoPopup');
  if (!cfgEl || !root) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY = 'vast_geo_popup';
  var ENDPOINT = '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true';
  var params = new URLSearchParams(window.location.search);
  var debugParam = cfg.debug ? params.get('vast_geo') : null;
  var currentCountry = String(cfg.current.country || '').toUpperCase();
  var allow = (cfg.allow || []).filter(function (c) { return c; });

  function log() {
    if (cfg.debug && window.console) {
      console.log.apply(console, ['[VAST Geo]'].concat([].slice.call(arguments)));
    }
  }

  if (cfg.design_mode && !cfg.preview) return;

  /* ---------- gespeicherte Entscheidung ---------- */

  function readDecision() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveDecision(country) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({
        country: country,
        until: Date.now() + (cfg.expiry_days || 30) * 864e5
      }));
    } catch (e) { /* Storage blockiert - dann eben bei jedem Besuch */ }
  }

  if (debugParam === 'reset') {
    try { window.localStorage.removeItem(KEY); } catch (e) {}
    log('Gespeicherte Entscheidung gelöscht');
  }

  /* ---------- Flagge ---------- */

  function flagEmoji(iso) {
    return iso.toUpperCase().replace(/./g, function (ch) {
      return String.fromCodePoint(127397 + ch.charCodeAt(0));
    });
  }

  // Windows rendert Flaggen-Emojis nicht (zeigt Buchstaben). Test: Schweizer Flagge muss Rot enthalten.
  var flagsSupported = (function () {
    try {
      var canvas = document.createElement('canvas');
      canvas.width = canvas.height = 24;
      var ctx = canvas.getContext('2d');
      if (!ctx) return false;
      ctx.font = '18px sans-serif';
      ctx.textBaseline = 'top';
      ctx.fillText(flagEmoji('CH'), 0, 0);
      var d = ctx.getImageData(0, 0, 24, 24).data;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] > 0 && d[i] > 150 && d[i + 1] < 110 && d[i + 2] < 110) return true;
      }
      return false;
    } catch (e) { return false; }
  })();

  /* ---------- Inhalte ---------- */

  function displayName(iso) {
    return cfg.names[iso] || cfg.countries[iso] || iso;
  }

  // Länderform für den Satz ("der Schweiz", "den USA"), Fallback auf den Anzeigenamen
  function sentenceName(iso) {
    return (cfg.names_from && cfg.names_from[iso]) || displayName(iso);
  }

  function fill(iso) {
    var vars = { country: displayName(iso), country_in: sentenceName(iso), currency: cfg.currencies[iso] || '' };

    root.querySelectorAll('[data-geo-text]').forEach(function (el) {
      var tpl = cfg.texts[el.getAttribute('data-geo-text')] || '';
      var out = tpl.replace(/\{(country_in|country|currency)\}/g, function (_, k) { return vars[k] || ''; });
      el.textContent = out;
      // Leere optionale Elemente (Subline, Vorteile) ausblenden
      if (!el.closest('button, h2')) {
        var target = el.closest('li') || el;
        target.hidden = !out.trim();
      }
    });

    var flag = root.querySelector('[data-geo-flag]');
    var badge = root.querySelector('[data-geo-badge]');
    var useFlag = cfg.show_flag && flagsSupported;
    if (flag) { flag.textContent = useFlag ? flagEmoji(iso) : ''; flag.hidden = !useFlag; }
    if (badge) { badge.textContent = iso; badge.hidden = useFlag || !cfg.show_flag; }
  }

  /* ---------- Öffnen / Schließen ---------- */

  var isOpen = false;
  var lastFocus = null;
  var closeTimer = null;

  function focusables() {
    return [].slice.call(root.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(iso, suggestion) {
    if (isOpen) return;
    fill(iso);

    root.querySelector('[data-geo-country]').value = iso;
    var lang = suggestion && suggestion.parts && suggestion.parts.language && suggestion.parts.language.handle;
    if (lang) root.querySelector('[data-geo-language]').value = lang;
    root.setAttribute('data-country', iso);

    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('vast-geo-open');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { root.classList.add('is-open'); });
    });

    var card = root.querySelector('[data-geo-card]');
    if (card) card.focus({ preventScroll: true });

    document.addEventListener('keydown', onKeydown);
    isOpen = true;
    log('Popup geöffnet für', iso, suggestion || '(keine Suggestion)');
  }

  function close(remember) {
    if (!isOpen) return;
    isOpen = false;
    if (remember) saveDecision(root.getAttribute('data-country'));

    root.classList.remove('is-open');
    document.documentElement.classList.remove('vast-geo-open');
    document.removeEventListener('keydown', onKeydown);

    closeTimer = setTimeout(function () {
      root.hidden = true;
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }, 260);
  }

  root.addEventListener('click', function (e) {
    if (e.target === root || e.target.hasAttribute('data-geo-backdrop') || e.target.closest('[data-geo-stay]') || e.target.closest('[data-geo-close]')) {
      e.preventDefault();
      close(true);
    }
  });

  var form = root.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      // Entscheidung merken, falls Ziel-Domain dieselbe bleibt (Markt ohne eigene Domain)
      saveDecision(root.getAttribute('data-country'));
      var btn = form.querySelector('[data-geo-switch]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    });
  }

  /* ---------- Consent-Banner abwarten ---------- */

  function bannerVisible() {
    var sel = cfg.consent_selector;
    if (!sel) return false;
    try {
      var el = document.querySelector(sel);
      return !!(el && el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden');
    } catch (e) { return false; }
  }

  function consentBlocking() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return true;
    } catch (e) {}
    return bannerVisible();
  }

  function whenConsentSettled(cb) {
    var proceed = function () {
      if (!consentBlocking()) return cb();
      log('Cookie-Banner aktiv, Popup wartet');
      var done = false;
      var timer = null;
      var finish = function () {
        if (done) return;
        done = true;
        if (timer) clearInterval(timer);
        document.removeEventListener('visitorConsentCollected', finish);
        log('Consent erledigt, Popup folgt');
        cb();
      };
      document.addEventListener('visitorConsentCollected', finish);
      timer = setInterval(function () { if (!consentBlocking()) finish(); }, 500);
    };

    // Customer Privacy API nachladen, falls noch nicht vorhanden (Consentmo lädt sie normalerweise selbst)
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { proceed(); });
        return;
      } catch (e) {}
    }
    proceed();
  }

  /* ---------- Entscheidung ---------- */

  function decide(detected, suggestion) {
    detected = String(detected || '').toUpperCase();
    if (!detected) return log('Kein Land erkannt');
    if (detected === currentCountry) return log('Land passt bereits:', detected);
    if (!cfg.countries[detected]) return log('Land wird nicht beliefert:', detected);
    if (allow.length && allow.indexOf(detected) === -1) return log('Land nicht in Liste:', detected, allow);

    var stored = readDecision();
    if (!debugParam && stored && stored.country === detected && stored.until > Date.now()) {
      return log('Entscheidung noch gültig:', stored);
    }

    whenConsentSettled(function () {
      setTimeout(function () { open(detected, suggestion); }, cfg.delay || 0);
    });
  }

  function detect() {
    // Debug: Land per URL simulieren, z. B. ?vast_geo=CH
    if (debugParam && /^[A-Za-z]{2}$/.test(debugParam)) {
      log('Simuliertes Land:', debugParam.toUpperCase());
      decide(debugParam, null);
      return;
    }

    // Gültige Entscheidung vorhanden: kein Request nötig
    var stored = readDecision();
    if (stored && stored.until > Date.now()) return log('Entscheidung noch gültig, kein Request:', stored);

    fetch(ENDPOINT, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
      .then(function (data) {
        log('Antwort browsing_context_suggestions:', data);
        var dv = data.detected_values || {};
        var detected = dv.country && dv.country.handle;
        var suggestions = data.suggestions || [];

        if (!detected && suggestions[0] && suggestions[0].parts && suggestions[0].parts.country) {
          detected = suggestions[0].parts.country.handle;
        }

        var suggestion = null;
        for (var i = 0; i < suggestions.length; i++) {
          var p = suggestions[i].parts;
          if (p && p.country && String(p.country.handle).toUpperCase() === String(detected).toUpperCase()) {
            suggestion = suggestions[i];
            break;
          }
        }
        decide(detected, suggestion);
      })
      .catch(function (err) { log('Erkennung fehlgeschlagen:', err); });
  }

  // Erst nach dem Laden starten, damit der Request nicht mit Seitenressourcen konkurriert
  if (document.readyState === 'complete') detect();
  else window.addEventListener('load', detect, { once: true });
})();